<template>



  <div class="question-records-container">



    <!-- 顶部导航栏 -->



    <div class="records-header">



      <div class="header-left">



        <i class="el-icon-arrow-left back-btn" @click="goBack"></i>



        <h1 class="page-title">做题记录</h1>



      </div>



      <div class="header-right">



        <el-radio-group v-model="langMode" size="small" style="margin-right: 10px;">



          <el-radio-button label="zh">中文</el-radio-button>



          <el-radio-button label="en">English</el-radio-button>



          <el-radio-button label="bi">双语</el-radio-button>



        </el-radio-group>



        <el-button



          type="primary"



          size="small"



          icon="el-icon-refresh"



          @click="refreshRecords"



          :loading="amcStatusLoading">



          刷新记录



        </el-button>



      </div>



    </div>







    <!-- 加载状态 -->



    <div v-if="loading" class="loading-container">



      <el-loading



        :loading="loading"



        text="正在加载做题记录..."



        background="rgba(0, 0, 0, 0.8)"



      />



    </div>







    <!-- 错误状态 -->



    <div v-else-if="error" class="error-container">



      <div class="error-content">



        <i class="el-icon-warning error-icon"></i>



        <p class="error-message">{{ error }}</p>



        <el-button type="primary" @click="refreshRecords">重新加载</el-button>



      </div>



    </div>







    <!-- 做题记录内容 -->



    <div v-else class="records-content">



      <!-- 统计信息 -->



      <div class="stats-section">



        <div class="stat-card">



          <div class="stat-number">{{ totalRecords }}</div>



          <div class="stat-label">总做题数</div>



        </div>



        <div class="stat-card">



          <div class="stat-number">{{ correctRecords }}</div>



          <div class="stat-label">答对题数</div>



        </div>



        <div class="stat-card">



          <div class="stat-number">{{ accuracy }}%</div>



          <div class="stat-label">正确率</div>



        </div>



        <div class="stat-card">



          <div class="stat-number">{{ uniqueQuestions }}</div>



          <div class="stat-label">涉及题目数</div>



        </div>



      </div>







      <!-- AMC 状态卡片展示 -->



      <div class="amc-status-section">



        <div class="amc-status-header">



          <div class="amc-title">学习活动概览</div>



          <!-- <div class="amc-subtitle">来自{{ subjectName ? ' ' + subjectName + ' ' : '' }}状态接口</div> -->



        </div>







        <div v-if="amcStatusLoading" class="amc-status-loading">正在加载{{ subjectName ? ' ' + subjectName + ' ' : '' }}状态...</div>



        <div v-else-if="amcStatusError" class="amc-status-error">{{ amcStatusError }}</div>



        <div v-else>



          <div v-if="mergedAmcStatusList && mergedAmcStatusList.length" class="amc-cards-grid">



            <div class="amc-card" v-for="item in mergedAmcStatusList" :key="item.id" @click="viewStatusDetail(item)">



              <div class="amc-card-header">



                <span class="amc-source" :class="'src-'+(item.source || '未知')">{{ item.source || '未知来源' }}<template v-if="item.createDate">（{{ formatDateOnly(item.createDate) }}）</template></span>



                <span class="amc-view-hint">点击查看详情 →</span>



              </div>



              <div class="amc-card-body">



                <div class="amc-metric">



                  <div class="amc-metric-icon">✅</div>



                  <div class="amc-metric-content">



                    <div class="amc-metric-label">答对</div>



                    <div class="amc-metric-value success">{{ item.rightCount || 0 }}</div>



                  </div>



                </div>



                <div class="amc-metric">



                  <div class="amc-metric-icon">🎯</div>



                  <div class="amc-metric-content">



                    <div class="amc-metric-label">正确率</div>



                    <div class="amc-metric-value" :class="calcAccuracy(item) >= 60 ? 'success' : 'warn'">{{ calcAccuracy(item) }}%</div>



                  </div>



                </div>



                <div class="amc-metric">



                  <div class="amc-metric-icon">📝</div>



                  <div class="amc-metric-content">



                    <div class="amc-metric-label">题目数量</div>



                    <div class="amc-metric-value">{{ getQuesCount(item) }}</div>



                  </div>



                </div>



              </div>







            </div>



          </div>



          <div v-else class="amc-status-empty">暂无{{ subjectName ? ' ' + subjectName + ' ' : '' }}活动数据</div>



        </div>



      </div>







      <!-- 筛选和搜索区域（临时隐藏表格时不展示） -->



      <div class="filter-section" v-if="showRecordsTable">



        <div class="filter-controls">



          <el-input



            v-model="searchKeyword"



            placeholder="搜索题目内容"



            prefix-icon="el-icon-search"



            @input="handleSearch"



            clearable



            style="width: 300px; margin-right: 15px;">



          </el-input>



          <el-select



            v-model="selectedStatus"



            placeholder="选择答题状态"



            @change="handleFilter"



            clearable



            style="width: 150px; margin-right: 15px;">



            <el-option label="全部" value=""></el-option>



            <el-option label="答对" value="correct"></el-option>



            <el-option label="答错" value="incorrect"></el-option>



          </el-select>



          <el-date-picker



            v-model="dateRange"



            type="daterange"



            range-separator="至"



            start-placeholder="开始日期"



            end-placeholder="结束日期"



            @change="handleDateFilter"



            style="width: 240px;">



          </el-date-picker>



        </div>



      </div>



      <!-- 做题记录表格（临时隐藏） -->



      <div class="table-section" v-if="showRecordsTable">



        <el-table



          :data="filteredRecords"



          v-loading="loading"



          stripe



          border



          style="width: 100%"



          :default-sort="{ prop: 'time', order: 'descending' }"



          empty-text="暂无做题记录">







          <el-table-column prop="id" label="记录ID" width="90" align="center" />



          <el-table-column prop="userId" label="用户ID" width="100" align="center" />







          <el-table-column prop="quesId" label="题目ID" width="90" align="center" />







          <el-table-column



            prop="quesContent"



            label="题目内容"



            min-width="300"



            show-overflow-tooltip>



            <template slot-scope="scope">



              <div class="question-content" v-html="formatQuestionContent(getQuestionContent(scope.row))"></div>



            </template>



          </el-table-column>







          <el-table-column prop="userAnswer" label="用户答案" width="140" align="center">



            <template slot-scope="scope">



              <span v-if="scope.row.userAnswer" class="user-answer">{{ scope.row.userAnswer }}</span>



              <span v-else class="no-answer">未答题</span>



            </template>



          </el-table-column>



          <el-table-column prop="answer" label="正确答案" width="120" align="center">



            <template slot-scope="scope">



              <span class="correct-answer">{{ scope.row.answer || scope.row.correctAnswer || '-' }}</span>



            </template>



          </el-table-column>







          <el-table-column prop="isRight" label="答题状态" width="120" align="center">



            <template slot-scope="scope">



              <div style="display: flex; flex-direction: column; gap: 4px; align-items: center;">



                <el-tag :type="getRecordCorrect(scope.row) ? 'success' : 'danger'" size="small">



                  {{ getRecordCorrect(scope.row) ? '正确' : '错误' }}



                </el-tag>



                <el-tag v-if="isTimeout(scope.row)" type="warning" size="mini">



                  超时



                </el-tag>



              </div>



            </template>



          </el-table-column>







          <el-table-column prop="duration" label="用时" width="100" align="center">



            <template slot-scope="scope">



              <span :style="{ color: isTimeout(scope.row) ? '#E6A23C' : '#606266' }">



                {{ formatDuration(scope.row.duration) }}



              </span>



            </template>



          </el-table-column>







          <el-table-column prop="knowledge" label="知识点" width="120" align="center">



            <template slot-scope="scope">{{ resolveKnowledgeName(scope.row.knowledge) }}</template>



          </el-table-column>



          <el-table-column prop="difficulty" label="难度" width="100" align="center">



            <template slot-scope="scope">



              <el-tag v-if="scope.row.difficulty" :type="getDifficultyType(scope.row.difficulty)" size="small">



                {{ formatDifficulty(scope.row.difficulty) }}



              </el-tag>



              <span v-else>-</span>



            </template>



          </el-table-column>



          <el-table-column prop="repoId" label="题库ID" width="100" align="center" />



          <el-table-column prop="mynote" label="我的笔记" min-width="180" show-overflow-tooltip />



          <el-table-column



            prop="judge"



            label="解析/评语"



            min-width="260"



            show-overflow-tooltip>



            <template slot-scope="scope">



              <div class="analysis-content" v-html="formatQuestionContent(getJudgeContent(scope.row))"></div>



            </template>



          </el-table-column>



          <el-table-column prop="isReview" label="标记复习" width="100" align="center">



            <template slot-scope="scope">



              <el-tag :type="scope.row.isReview ? 'warning' : 'info'" size="small">



                {{ scope.row.isReview ? '是' : '否' }}



              </el-tag>



            </template>



          </el-table-column>



          <el-table-column prop="count" label="做题次数" width="100" align="center" />



          <el-table-column prop="wrongCount" label="错误次数" width="100" align="center" />







          <el-table-column



            prop="score"



            label="得分"



            width="80"



            align="center">



            <template slot-scope="scope">



              <span :class="getRecordCorrect(scope.row) ? 'score-correct' : 'score-incorrect'">



                {{ scope.row.score || (getRecordCorrect(scope.row) ? 1 : 0) }}



              </span>



            </template>



          </el-table-column>







          <el-table-column



            prop="time"



            label="答题时间"



            width="180"



            align="center"



            sortable>



            <template slot-scope="scope">



              <span>{{ formatDateTime(getRecordTime(scope.row)) }}</span>



            </template>



          </el-table-column>







          <el-table-column



            label="操作"



            width="120"



            align="center"



            fixed="right">



            <template slot-scope="scope">



              <el-button



                type="text"



                size="small"



                @click="viewQuestionDetail(scope.row)">



                查看详情



              </el-button>



            </template>



          </el-table-column>



        </el-table>







        <!-- 分页（临时隐藏表格时不展示） -->



        <div class="pagination-section" v-if="showRecordsTable && totalRecords > 0">



          <el-pagination



            @size-change="handleSizeChange"



            @current-change="handleCurrentChange"



            :current-page="currentPage"



            :page-sizes="[10, 20, 50, 100]"



            :page-size="pageSize"



            :total="totalRecords"



            layout="total, sizes, prev, pager, next, jumper">



          </el-pagination>



        </div>



      </div>



    </div>







    <!-- 题目详情弹窗 -->



    <el-dialog



      title="题目详情"



      :visible.sync="showQuestionDialog"



      width="80%"



      :before-close="handleCloseQuestionDialog">



      <div v-if="selectedQuestion" class="question-detail" v-loading="dialogLoading">



        <div class="question-header">



          <h3>题目ID: {{ selectedQuestion.quesId }}</h3>



          <el-tag



            :type="selectedQuestion.isCorrect ? 'success' : 'danger'"



            size="medium">



              {{ selectedQuestion.isCorrect ? '回答正确' : '回答错误' }}



          </el-tag>



        </div>







        <div class="question-content-detail">



          <h4>题目内容：</h4>



          <div class="content-text" v-html="formatQuestionContent(getQuestionContent(selectedQuestion))"></div>



        </div>







        <div class="question-image-section" v-if="selectedQuestion && selectedQuestion.image">



          <h4>题目图片：</h4>



          <img :src="resolveImageUrl(selectedQuestion.image)" alt="题目图片" style="max-width: 100%; border: 1px solid #eee; border-radius: 4px;" />



        </div>







        <div class="answer-section">



          <div class="answer-row">



            <span class="answer-label">你的答案：</span>



            <span class="answer-value" :class="selectedQuestion.isCorrect ? 'correct' : 'incorrect'">



              {{ selectedQuestion.userAnswer || '未答题' }}



            </span>



          </div>



          <div class="answer-row">



            <span class="answer-label">正确答案：</span>



            <span class="answer-value correct">{{ selectedQuestion.correctAnswer || '无答案' }}</span>



          </div>



          <div class="answer-row" v-if="selectedQuestion.score !== undefined">



            <span class="answer-label">得分：</span>



            <span class="answer-value" :class="selectedQuestion.isCorrect ? 'correct' : 'incorrect'">



              {{ selectedQuestion.score || (selectedQuestion.isCorrect ? 1 : 0) }}分



            </span>



          </div>



        </div>







        <div class="analysis-section" v-if="selectedQuestion.judgeCn || selectedQuestion.judgeEn || selectedQuestion.judge">



          <h4>题目解析：</h4>



          <div class="analysis-content" v-html="formatQuestionContent(getJudgeContent(selectedQuestion))"></div>



        </div>







        <div class="time-section">



          <div class="time-row">



            <span class="time-label">答题时间：</span>



            <span class="time-value">{{ formatDateTime(selectedQuestion.createTime) }}</span>



          </div>



        </div>



      </div>







      <span slot="footer" class="dialog-footer">



        <el-button @click="showQuestionDialog = false">关闭</el-button>



      </span>



    </el-dialog>







    <!-- AMC 状态详情弹窗 -->



    <el-dialog



      :title="statusDetailTitle || '详情'"



      :visible.sync="showStatusDetailDialog"



      width="95%">



      <div v-loading="statusDialogLoading">



        <div style="margin-bottom: 15px; display: flex; justify-content: space-between; align-items: center;">



          <span style="color: #666; font-size: 14px;">点击行可查看详细内容</span>



          <el-radio-group v-model="langMode" size="small">



            <el-radio-button label="zh">中文</el-radio-button>



            <el-radio-button label="en">English</el-radio-button>



            <el-radio-button label="bi">双语</el-radio-button>



          </el-radio-group>



        </div>



        <el-table



          :data="statusDetailRecords"



          border



          stripe



          size="small"



          style="width: 100%"



          empty-text="暂无相关记录"



          @row-click="openRecordDetail"



          :row-style="{cursor: 'pointer'}">



          <el-table-column prop="id" label="记录ID" width="90" align="center" />



          <el-table-column prop="userId" label="用户ID" width="100" align="center" />



          <el-table-column prop="quesId" label="题目ID" width="100" align="center" />



          <el-table-column



            prop="quesContent"



            label="题目内容"



            min-width="260"



            show-overflow-tooltip>



            <template slot-scope="scope">



              <div class="question-content" v-html="formatQuestionContent(getQuestionContent(scope.row))"></div>



            </template>



          </el-table-column>



          <el-table-column prop="userAnswer" label="用户答案" width="140" align="center" />



          <el-table-column prop="answer" label="正确答案" width="120" align="center">



            <template slot-scope="scope">



              {{ scope.row.answer || scope.row.correctAnswer || '-' }}



            </template>



          </el-table-column>



          <el-table-column label="答题状态" width="120" align="center">



            <template slot-scope="scope">



              <div style="display: flex; flex-direction: column; gap: 4px; align-items: center;">



                <el-tag :type="getRecordCorrect(scope.row) ? 'success' : 'danger'" size="small">



                  {{ getRecordCorrect(scope.row) ? '正确' : '错误' }}



                </el-tag>



                <el-tag v-if="isTimeout(scope.row)" type="warning" size="mini">



                  超时



                </el-tag>



              </div>



            </template>



          </el-table-column>



          <el-table-column prop="duration" label="用时" width="100" align="center">



            <template slot-scope="scope">



              <span :style="{ color: isTimeout(scope.row) ? '#E6A23C' : '#606266' }">



                {{ formatDuration(scope.row.duration) }}



              </span>



            </template>



          </el-table-column>



          <el-table-column



            prop="judge"



            label="解析/评语"



            min-width="220"



            show-overflow-tooltip>



            <template slot-scope="scope">



              <div class="analysis-content" v-html="formatQuestionContent(getJudgeContent(scope.row))"></div>



            </template>



          </el-table-column>



          <el-table-column prop="knowledge" label="知识点" width="120" align="center">



            <template slot-scope="scope">{{ resolveKnowledgeName(scope.row.knowledge) }}</template>



          </el-table-column>



          <el-table-column prop="difficulty" label="难度" width="100" align="center">



            <template slot-scope="scope">



              <el-tag v-if="scope.row.difficulty" :type="getDifficultyType(scope.row.difficulty)" size="small">



                {{ formatDifficulty(scope.row.difficulty) }}



              </el-tag>



              <span v-else>-</span>



            </template>



          </el-table-column>



          <el-table-column prop="repoId" label="题库ID" width="100" align="center" />



          <el-table-column prop="count" label="次数" width="90" align="center" />



          <el-table-column prop="wrongCount" label="错误次数" width="100" align="center" />



          <el-table-column prop="mynote" label="我的笔记" min-width="160" show-overflow-tooltip />



          <el-table-column label="提交图片" width="120" align="center">



            <template slot-scope="scope">



              <div v-if="parseImages(scope.row.images).length > 0" class="record-images" @click.stop>



                <el-image



                  v-for="(img, idx) in parseImages(scope.row.images)"



                  :key="idx"



                  :src="img.url || img.path || img"



                  :preview-src-list="parseImages(scope.row.images).map(i => i.url || i.path || i)"



                  style="width: 40px; height: 40px; margin: 2px; cursor: pointer;"



                  fit="cover"



                />



              </div>



              <span v-else style="color: #999;">-</span>



            </template>



          </el-table-column>



          <el-table-column label="答题时间" width="180" align="center">



            <template slot-scope="scope">



              {{ formatDateTime(getRecordTime(scope.row)) }}



            </template>



          </el-table-column>



        </el-table>



      </div>



      <span slot="footer" class="dialog-footer">



        <el-button @click="showStatusDetailDialog = false">关闭</el-button>



      </span>



    </el-dialog>







    <!-- 二级：记录详情弹窗（展示全部字段） -->



    <el-dialog



      :visible.sync="showRecordDetailDialog"



      width="90%"



      :show-close="true"



      custom-class="record-detail-dialog"



      top="5vh">



      <div slot="title" class="record-dialog-title">



        <div class="title-left">



          <i class="el-icon-document"></i>



          <span>答题记录详情</span>



        </div>



        <div class="title-right">



          <el-tag :type="getRecordCorrect(recordDetail) ? 'success' : 'danger'" effect="dark" size="medium">



            <i :class="getRecordCorrect(recordDetail) ? 'el-icon-success' : 'el-icon-error'"></i>



            {{ getRecordCorrect(recordDetail) ? '答对了' : '答错了' }}



          </el-tag>



        </div>



      </div>







      <div v-if="recordDetail" class="record-detail-wrapper" v-loading="recordDetailLoading">



        <!-- 顶部信息卡片 -->



        <div class="info-cards-row">



          <div class="info-card">



            <div class="info-card-icon" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">



              <i class="el-icon-time"></i>



            </div>



            <div class="info-card-content">



              <div class="info-card-label">答题时间</div>



              <div class="info-card-value">{{ formatDateTime(getRecordTime(recordDetail)) }}</div>



            </div>



          </div>







          <div class="info-card">



            <div class="info-card-icon" style="background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);">



              <i class="el-icon-timer"></i>



            </div>



            <div class="info-card-content">



              <div class="info-card-label">用时</div>



              <div class="info-card-value" :style="{ color: isTimeout(recordDetail) ? '#E6A23C' : '#606266' }">



                {{ formatDuration(recordDetail.duration) }}



                <el-tag v-if="isTimeout(recordDetail)" type="warning" size="mini" style="margin-left: 4px;">超时</el-tag>



              </div>



            </div>



          </div>







          <div class="info-card">



            <div class="info-card-icon" style="background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);">



              <i class="el-icon-star-off"></i>



            </div>



            <div class="info-card-content">



              <div class="info-card-label">难度</div>



              <div class="info-card-value">



                <el-tag v-if="recordDetail.difficulty" :type="getDifficultyType(recordDetail.difficulty)" size="small">



                  {{ formatDifficulty(recordDetail.difficulty) }}



                </el-tag>



                <span v-else style="color: #999;">未知</span>



              </div>



            </div>



          </div>







          <div class="info-card">



            <div class="info-card-icon" style="background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);">



              <i class="el-icon-refresh"></i>



            </div>



            <div class="info-card-content">



              <div class="info-card-label">练习次数</div>



              <div class="info-card-value">



                第 {{ recordDetail.count || 1 }} 次



                <span v-if="recordDetail.wrongCount > 0" style="color: #F56C6C; font-size: 12px; margin-left: 4px;">



                  (错 {{ recordDetail.wrongCount }})



                </span>



              </div>



            </div>



          </div>



        </div>







        <!-- 知识点标签 -->



        <div v-if="recordDetail.knowledge" class="knowledge-tags-section">



          <div class="section-title">



            <i class="el-icon-collection-tag"></i>



            <span>知识点</span>



          </div>



          <div class="knowledge-tags">



            <el-tag



              v-for="(k, idx) in splitKnowledge(recordDetail.knowledge)"



              :key="idx"



              type="info"



              effect="plain"



              size="medium">



              {{ k }}



            </el-tag>



          </div>



        </div>







        <!-- 题目内容 -->



        <div class="content-section">



          <div class="section-title">



            <i class="el-icon-edit-outline"></i>



            <span>题目内容</span>



          </div>



          <div class="content-box record-question-content">



            <div v-html="formatQuestionContent(getQuestionContent(recordDetail))"></div>



          </div>



        </div>







        <!-- 题目图片 -->



        <div class="content-section" v-if="recordDetail.image">



          <div class="section-title">



            <i class="el-icon-picture-outline"></i>



            <span>题目图片</span>



          </div>



          <div class="content-box">



            <img :src="resolveImageUrl(recordDetail.image)" alt="题目图片" class="question-image" />



          </div>



        </div>







        <!-- 答案对比 -->



        <div v-if="isCodeRecord(recordDetail)" class="content-section">



          <div class="section-title">



            <i class="el-icon-monitor"></i>



            <span>我的代码</span>



          </div>



          <div class="content-box code-answer-box">



            <pre>{{ recordDetail.sourceCode || '暂无提交代码' }}</pre>



          </div>



          <div class="code-meta-row">



            <div class="answer-box user-answer" :class="{ 'wrong-answer': !getRecordCorrect(recordDetail) }">



              <div class="answer-header">



                <i class="el-icon-cpu"></i>



                <span>判题结果</span>



              </div>



              <div class="answer-content">



                {{ recordDetail.status || '未判题' }}



              </div>



            </div>



            <div class="answer-box correct-answer">



              <div class="answer-header">



                <i class="el-icon-data-analysis"></i>



                <span>测试点结果</span>



              </div>



              <div class="answer-content">



                {{ recordDetail.answer || recordDetail.correctAnswer || '暂无结果' }}



              </div>



            </div>



          </div>



        </div>







        <div v-else class="answer-comparison">



          <div class="answer-box user-answer" :class="{ 'wrong-answer': !getRecordCorrect(recordDetail) }">



            <div class="answer-header">



              <i class="el-icon-user"></i>



              <span>你的答案</span>



            </div>



            <div class="answer-content">



              {{ recordDetail.userAnswer || '未答题' }}



            </div>



          </div>







          <div class="answer-divider">



            <i :class="getRecordCorrect(recordDetail) ? 'el-icon-success' : 'el-icon-right'"



               :style="{ color: getRecordCorrect(recordDetail) ? '#67C23A' : '#909399' }"></i>



          </div>







          <div class="answer-box correct-answer">



            <div class="answer-header">



              <i class="el-icon-circle-check"></i>



              <span>正确答案</span>



            </div>



            <div class="answer-content">



              {{ recordDetail.answer || recordDetail.correctAnswer || '无答案' }}



            </div>



          </div>



        </div>







        <!-- 解析 -->



        <div class="content-section" v-if="recordDetail.judgeCn || recordDetail.judgeEn || recordDetail.judge">



          <div class="section-title">



            <i class="el-icon-reading"></i>



            <span>解析</span>



          </div>



          <div class="content-box analysis-content">



            <div v-html="formatQuestionContent(getJudgeContent(recordDetail))"></div>



          </div>



        </div>







        <!-- 我的笔记 -->



        <div class="content-section" v-if="recordDetail.mynote">



          <div class="section-title">



            <i class="el-icon-notebook-2"></i>



            <span>我的笔记</span>



          </div>



          <div class="content-box note-content">



            {{ recordDetail.mynote }}



          </div>



        </div>







        <!-- 底部元信息 -->



        <div class="meta-info">



          <span><i class="el-icon-postcard"></i> 记录ID: {{ recordDetail.id }}</span>



          <span><i class="el-icon-document-copy"></i> 题目ID: {{ recordDetail.quesId }}</span>



          <span v-if="recordDetail.isReview"><i class="el-icon-refresh-right"></i> 复习题目</span>



        </div>



      </div>







      <span slot="footer" class="dialog-footer">



        <el-button @click="showRecordDetailDialog = false" size="medium">关闭</el-button>



      </span>



    </el-dialog>



  </div>



</template>







<script>



import { getRecordsByUserId, getRecordsByQuesId } from '@/api/userQuestionRecord'



import { quDetail } from '@/api/question'



import { getGespQuestionById } from '@/api/gespQuestion'



import { pagingGespQuestions } from '@/api/gespQuestion'



import { getLatestSubmitBatch } from '@/api/gespCodeSubmit'



import { getTokenInfo } from '@/utils/jwtUtils'



import { userStatusByUser } from '@/api/userStatus'



import { batchGetGeneralKnowledgeNames } from '@/api/knowledge'



import { listPastPaperRecords } from '@/api/pastPaperRecord'



import { getQuestionById as getCourseQuestionById } from '@/api/courseQuestion'







import { getMinioUrl } from '@/utils/minio'







export default {



  name: 'QuestionRecords',



  data() {



    const GESP_CODE_REPO_ID = 27



    return {



      GESP_CODE_REPO_ID,



      // 加载状态



      loading: false,



      // 错误信息



      error: null,



      // AMC状态加载



      amcStatusLoading: false,



      amcStatusError: null,



      amcStatusList: [],



      // 所有记录



      allRecords: [],



      // 筛选后的记录



      filteredRecords: [],



      // 当前用户ID



      currentUserId: null,







      // 搜索和筛选



      searchKeyword: '',



      selectedStatus: '',



      dateRange: null,







      // 分页



      currentPage: 1,



      pageSize: 20,







      // 题目详情弹窗



      showQuestionDialog: false,



      selectedQuestion: null,



      dialogLoading: false,



      // 临时隐藏做题记录表格



      showRecordsTable: false,



      // AMC 状态详情弹窗



      showStatusDetailDialog: false,



      statusDialogLoading: false,



      statusDetailTitle: '',



      statusDetailRecords: [],



      pastPaperDurationMap: {},



      // 二级记录详情弹窗



      showRecordDetailDialog: false,



      recordDetailLoading: false,



      recordDetail: null,



      // 卡片内联展开所需状态



      expandedCardId: null,



      cardDetails: {}, // { [cardId]: rows[] }



      cardLoading: {}, // { [cardId]: boolean }



      // 语言模式：zh(中文)/en(英文)/bi(双语)



      langMode: 'bi',



      // 知识点ID→名称映射



      knowledgeNameMap: {}



    }



  },



  computed: {



    // 总记录数



    totalRecords() {



      return this.allRecords.length



    },



    // 答对记录数



    correctRecords() {



      return this.allRecords.filter(record => this.getRecordCorrect(record)).length



    },



    // 正确率



    accuracy() {



      if (this.totalRecords === 0) return 0



      return Math.round((this.correctRecords / this.totalRecords) * 100)



    },



    // 涉及题目数



    uniqueQuestions() {



      const questionIds = new Set(this.allRecords.map(record => record.quesId))



      return questionIds.size



    },







    // 顶部统计：基于 AMC 卡片聚合



    mergedAmcStatusList() {

      const list = Array.isArray(this.amcStatusList) ? this.amcStatusList : []

      const map = new Map()

      const getStatusDate = (item) => {

        const value = item && item.createTime ? String(item.createTime) : ''

        if (!value) return ''

        const normalized = value.replace('T', ' ')

        return normalized.slice(0, 10)

      }

      const shouldGroupByDate = (item) => {

        const source = String((item && item.source) || '')

        return source.startsWith('智能练习') || source.endsWith('真题')

      }

      list.forEach(item => {

        const statusDate = getStatusDate(item)

        const key = shouldGroupByDate(item) && statusDate

          ? `${item.source || '未知来源'}#${statusDate}`

          : String(item.source || '未知来源')

        if (!map.has(key)) {

          map.set(key, {

            id: item.id,



            userId: item.userId,



            repoId: item.repoId,



            source: item.source,

            createDate: statusDate,



            quesList: String(item.quesList || ''),



            count: Number(item.count || 0),



            rightCount: Number(item.rightCount || 0),



            createTime: item.createTime,



            _originalItems: [item]

          })



        } else {

          const merged = map.get(key)

          const existingIds = new Set(
            String(merged.quesList || '').split(/[;,]/).map(x => x.trim()).filter(Boolean)
          )

          const newIds = String(item.quesList || '').split(/[;,]/).map(x => x.trim()).filter(Boolean)

          newIds.forEach(id => existingIds.add(id))

          merged.quesList = Array.from(existingIds).join(';')

          merged.count = existingIds.size

          merged.rightCount = (merged.rightCount || 0) + Number(item.rightCount || 0)

          if (!merged.createTime || (item.createTime && String(item.createTime) > String(merged.createTime))) {

            merged.createTime = item.createTime

          }

          merged._originalItems.push(item)

        }

      })



      return Array.from(map.values())



    },



    amcTotalQuestions() {



      if (!Array.isArray(this.amcStatusList)) return 0



      return this.amcStatusList.reduce((sum, item) => sum + this.getQuesCount(item), 0)



    },



    amcRightTotal() {



      if (!Array.isArray(this.amcStatusList)) return 0



      return this.amcStatusList.reduce((sum, item) => {



        const total = this.getQuesCount(item)



        let right = parseInt(item && item.rightCount, 10)



        if (isNaN(right)) right = 0



        // 边界保护：0 ≤ right ≤ total



        right = Math.min(Math.max(right, 0), total)



        return sum + right



      }, 0)



    },



    amcAccuracy() {



      const total = this.amcTotalQuestions



      const right = this.amcRightTotal



      if (!total) return 0



      return Math.round((right / total) * 100)



    },



    subjectName() {



      const code = this.$route?.query?.courseTypeCode || ''



      if (code) return code



      const level = this.$route?.query?.level || ''



      if (level) return level



      return ''



    }



  },



  created() {



    this.hideSidebarAndNavbar()



    this.initPage()



  },



  beforeDestroy() {



    this.showSidebarAndNavbar()



  },



  methods: {



    // 解析images字段（JSON字符串或数组）



    parseImages(images) {



      if (!images) return []



      if (Array.isArray(images)) return images



      try {



        const parsed = JSON.parse(images)



        return Array.isArray(parsed) ? parsed : []



      } catch (e) {



        return []



      }



    },



    // 兼容 isRight / isCorrect 字段，统一返回布尔正确性



    getRecordCorrect(row) {



      if (!row) return false



      if (typeof row.isRight === 'number') return row.isRight === 1



      if (typeof row.isRight === 'boolean') return row.isRight



      if (typeof row.isCorrect === 'boolean') return row.isCorrect



      if (typeof row.isCorrect === 'number') return row.isCorrect === 1



      if (typeof row.status === 'string') return String(row.status).toUpperCase() === 'AC'



      return false



    },







    // 兼容 time / createTime 字段，统一返回时间字符串



    getRecordTime(row) {



      if (!row) return null



      return row.time || row.createTime || row.submitTime || null



    },



    // 判断是否超时（超过200秒）



    isTimeout(row) {
      if (!row || !row.duration) return false

      const durationMs = this.normalizeDurationMs(row.duration)

      return !isNaN(durationMs) && durationMs > 200 * 1000

    },



    normalizeDurationMs(duration) {

      if (duration === null || duration === undefined || duration === '' || duration === 0 || duration === '0') return NaN

      if (typeof duration === 'string') {

        const trimmed = duration.trim()

        if (!trimmed) return NaN

        const numeric = Number(trimmed)

        if (isNaN(numeric) || numeric <= 0) return NaN

        return numeric >= 1000 ? numeric : numeric * 1000

      }

      const numeric = Number(duration)

      if (isNaN(numeric) || numeric <= 0) return NaN

      return numeric >= 1000 ? numeric : numeric * 1000

    },



    // 格式化用时显示



    formatDuration(duration) {

      if (duration === null || duration === undefined || duration === '' || duration === 0 || duration === '0') return '未记录'

      const durationMs = this.normalizeDurationMs(duration)

      if (isNaN(durationMs) || durationMs <= 0) return typeof duration === 'string' ? duration : '未记录'

      const totalSeconds = Math.floor(durationMs / 1000)

      if (totalSeconds <= 0) return '1秒'

      if (totalSeconds < 60) {

        return `${totalSeconds}秒`

      }

      const minutes = Math.floor(totalSeconds / 60)

      const remainingSeconds = totalSeconds % 60

      return `${minutes}分${remainingSeconds}秒`

    },



    // 隐藏侧边栏和导航栏



    hideSidebarAndNavbar() {



      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })







      const sidebar = document.querySelector('.sidebar-container')



      const navbar = document.querySelector('.navbar')







      if (sidebar) {



        sidebar.style.display = 'none'



      }



      if (navbar) {



        navbar.style.display = 'none'



      }







      const appMain = document.querySelector('.app-main')



      if (appMain) {



        appMain.style.padding = '0'



        appMain.style.margin = '0'



      }



    },







    // 恢复侧边栏和导航栏



    showSidebarAndNavbar() {



      this.$store.dispatch('app/openSideBar', { withoutAnimation: false })







      const sidebar = document.querySelector('.sidebar-container')



      const navbar = document.querySelector('.navbar')







      if (sidebar) {



        sidebar.style.display = ''



      }



      if (navbar) {



        navbar.style.display = ''



      }







      const appMain = document.querySelector('.app-main')



      if (appMain) {



        appMain.style.padding = ''



        appMain.style.margin = ''



      }



    },







    // 初始化页面



    async initPage() {



      // 获取当前用户ID



      const userInfo = getTokenInfo()



      this.currentUserId = userInfo ? userInfo.id : null



      if (!this.currentUserId) {



        this.$message.warning('未获取到用户信息')



        return



      }







      this.amcStatusLoading = true



      this.amcStatusError = null



      try {



        const repoId = this.$route?.query?.repoId || this.$route?.params?.repoId || null







        // 1. 获取用户做题记录（从 t_user_question_record 表，用于顶部统计）



        const recordResp = await getRecordsByUserId(this.currentUserId, repoId)



        const records = recordResp && recordResp.data ? recordResp.data : []



        this.allRecords = Array.isArray(records) ? records : []



        console.log('[QuestionRecords] 用户做题记录 =', this.allRecords)







        // 加载知识点名称



        const allKnowledge = this.allRecords.map(r => r.knowledge).filter(k => k)



        if (allKnowledge.length > 0) {



          await this.ensureKnowledgeNames(allKnowledge)



        }







        // 2. 获取学习活动概览（从 t_status 表，用于展示学习活动卡片）



        const statusResp = await userStatusByUser(this.currentUserId, repoId)



        const statusData = statusResp && statusResp.data ? statusResp.data : []



        this.amcStatusList = Array.isArray(statusData) ? statusData : []



        console.log('[QuestionRecords] 学习活动概览 =', this.amcStatusList)







        const codeIdentifiers = this.collectCodeIdentifiersFromStatusList(this.amcStatusList)



        if (codeIdentifiers.length > 0) {



          const codeRows = await this.loadCodeStatusRows(codeIdentifiers)



          this.mergeCodeRecordsIntoAllRecords(codeRows)



          console.log('[QuestionRecords] 合并编程题最新提交记录 =', codeRows)



        }







        // 预留：根据记录调整界面



        this.applyAmcStatusToUI()



      } catch (e) {



        console.warn('获取数据失败:', e)



        this.amcStatusError = '获取数据失败'



        this.allRecords = []



        this.amcStatusList = []



      } finally {



        this.amcStatusLoading = false



      }



    },







    // 根据 AMC 状态联动界面（占位方法，后续按业务规则完善）



    applyAmcStatusToUI() {



      // 示例：如果需要根据状态默认筛选错题，可在此设置



      // if (this.amcStatusList.some(s => s.preferIncorrectOnly)) {



      //   this.selectedStatus = 'incorrect'



      // }



      // 当前占位：不做视觉变更，仅作为扩展点



    },







    // 计算正确率（百分比, 四舍五入）



    calcAccuracy(row) {



      // 使用前端卡片展示的“题目数量”和“答对数”来计算



      const total = this.getQuesCount(row)



      let right = Number(row && row.rightCount) || 0



      if (!total) return 0



      // 边界保护：答对数不超过总题数且不小于0



      right = Math.min(Math.max(right, 0), total)



      return Math.round((right / total) * 100)



    },







    // 解析 quesList 为数组



    getQuesIds(row) {



      const s = row && row.quesList



      if (!s) return []



      return String(s)



        .split(/[;,]/)



        .map(x => x.trim())



        .filter(Boolean)



    },







    // 题目数量



    getQuesCount(row) {



      return this.getQuesIds(row).length



    },







    isCodeRecord(row) {



      if (!row) return false



      return row.recordType === 'code' || row.questionType === 'code'



    },







    isGespCodeIdentifier(value) {



      const raw = String(value == null ? '' : value).trim()



      if (!raw) return false



      if (raw.startsWith('code:')) return true



      return /GESP/i.test(raw)



    },







    async resolveGespCodeQuestionsByIdentifiers(ids) {



      const identifiers = Array.isArray(ids) ? ids.map(id => String(id || '').trim()).filter(Boolean) : []



      if (!identifiers.length) return []



      const repoId = this.GESP_CODE_REPO_ID



      const findQuestionFromPaging = async(identifier, repoId) => {



        const res = await pagingGespQuestions({



          pageNum: 1,



          pageSize: 20,



          keyword: identifier,



          repoId: repoId || undefined



        })



        const raw = res?.data?.data ?? res?.data ?? {}



        const records = Array.isArray(raw?.records) ? raw.records : (Array.isArray(raw?.list) ? raw.list : (Array.isArray(raw) ? raw : []))



        const normalizedIdentifier = identifier.replace(/[-_\s]/g, '').toUpperCase()



        const exact = records.find(q => String(q?.number || '').trim() === identifier)



        const normalized = records.find(q => String(q?.number || '').replace(/[-_\s]/g, '').toUpperCase() === normalizedIdentifier)



        const byKeyword = records.find(q => {



          const title = String(q?.title || '').toLowerCase()



          const content = String(q?.content || q?.description || '').toLowerCase()



          const number = String(q?.number || '').toLowerCase()



          const keyword = String(identifier || '').toLowerCase()



          return number.includes(keyword) || title.includes(keyword) || content.includes(keyword)



        })



        return {



          question: exact || normalized || byKeyword || records[0] || null,



          candidateCount: records.length



        }



      }







      const tasks = identifiers.map(identifier => {



        const numericId = identifier.startsWith('code:')



          ? Number(identifier.replace(/^code:/i, '').trim())



          : (/^\d+$/.test(identifier) ? Number(identifier) : NaN)



        if (Number.isFinite(numericId) && numericId > 0) {



          return getGespQuestionById(numericId)



            .then(res => ({ identifier, question: res?.data?.data ?? res?.data ?? null }))



            .catch(() => ({ identifier, question: null }))



        }







        return findQuestionFromPaging(identifier, repoId)



          .then(async firstPass => {



            let question = firstPass.question



            let candidateCount = firstPass.candidateCount



            console.log('[QuestionRecords] resolveGespCodeQuestion', {



              identifier,



              repoId,



              matchedQuestionId: question?.id,



              matchedNumber: question?.number,



              candidateCount



            })



            return { identifier, question }



          })



          .catch(() => ({ identifier, question: null }))



      })







      const results = await Promise.all(tasks)



      return results.filter(item => item && item.question)



    },







    normalizeCodeSubmitRecord(submit, question) {



      if (!question) return null



      const passedCount = Number(submit?.passedCount || 0)



      const totalCount = Number(submit?.totalCount || 0)



      const status = String(submit?.status || '').toUpperCase()



      return {



        ...(submit || {}),



        id: submit?.id || `code-${question.id}`,



        userId: submit?.userId || this.currentUserId,



        quesId: Number(submit?.quesId || question.id),



        repoId: submit?.repoId || question.repoId,



        number: question.number || question.questionNumber || question.displayNumber || '',



        quesContent: question.description || question.content || question.title || '',



        quescontentCn: question.description || question.content || question.title || '',



        quescontentEn: question.descriptionEn || question.contentEn || '',



        answer: totalCount > 0 ? `${passedCount}/${totalCount}` : (status || '-'),



        correctAnswer: totalCount > 0 ? `${passedCount}/${totalCount}` : (status || '-'),



        userAnswer: submit?.lang ? `${submit.lang} / ${status || '已提交'}` : (status || '未找到提交记录'),



        judge: submit?.errorMsg || (totalCount > 0 ? `通过测试点：${passedCount}/${totalCount}` : (submit ? '' : '未查到代码提交记录')),



        judgeCn: submit?.errorMsg || (totalCount > 0 ? `通过测试点：${passedCount}/${totalCount}` : (submit ? '' : '未查到代码提交记录')),



        judgeEn: submit?.errorMsg || '',



        difficulty: question.difficulty,



        title: question.title,



        source: question.source,



        knowledge: question.knowledge,



        duration: submit?.timeUsed != null ? `${submit.timeUsed}ms` : '未记录',



        createTime: submit?.submitTime,



        submitTime: submit?.submitTime,



        time: submit?.submitTime,



        isCorrect: status === 'AC',



        score: status === 'AC' ? 1 : 0,



        count: 1,



        wrongCount: status === 'AC' ? 0 : 1,



        questionType: 'code',



        recordType: 'code',



        sourceCode: submit?.code,



        status



      }



    },







    async enrichObjectiveRows(rows) {



      const list = Array.isArray(rows) ? rows : []



      const tasks = list.map(async row => {



        if (!row || this.isCodeRecord(row) || !row.quesId) return row



        const hasJudge = row.judgeCn || row.judgeEn || row.judge || row.analysis || row.analysisCn || row.analysisEn



        if (hasJudge) return row



        try {



          const res = await getCourseQuestionById(row.quesId)



          const q = res?.data?.data ?? res?.data ?? res ?? null



          if (!q) return row



          return {



            ...row,



            judge: row.judge || q.analysis || q.judge || '',



            judgeCn: row.judgeCn || q.analysisCn || q.judgeCn || q.analysis || q.judge || '',



            judgeEn: row.judgeEn || q.analysisEn || q.judgeEn || '',



            image: row.image || q.image,



            quesContent: row.quesContent || q.content || q.quesContent || '',



            quescontentCn: row.quescontentCn || row.quesContentCn || q.contentCn || q.quescontentCn || q.quesContentCn || '',



            quescontentEn: row.quescontentEn || row.quesContentEn || q.contentEn || q.quescontentEn || q.quesContentEn || ''



          }



        } catch (e) {



          return row



        }



      })



      return Promise.all(tasks)



    },







    getElapsedSecondsFromPastPaper(record) {



      if (!record) return null



      const duration = Number(record.duration)



      if (Number.isFinite(duration) && duration > 0) return duration



      let detail = record.answerDetail



      if (typeof detail === 'string') {



        try {



          detail = JSON.parse(detail)



        } catch (e) {



          detail = null



        }



      }



      const elapsed = Number(detail?.meta?.elapsedSeconds)



      return Number.isFinite(elapsed) && elapsed > 0 ? elapsed : null



    },







    async ensurePastPaperDurations() {



      if (!this.currentUserId) return



      const repoIdRaw = this.$route?.query?.repoId || this.$route?.params?.repoId || null



      const repoId = repoIdRaw != null && String(repoIdRaw).trim() !== '' ? Number(repoIdRaw) || repoIdRaw : null



      if (!repoId) return



      if (this.pastPaperDurationMap && Object.keys(this.pastPaperDurationMap).length > 0) return



      try {



        const resp = await listPastPaperRecords(this.currentUserId, repoId)



        const records = Array.isArray(resp?.data?.data) ? resp.data.data : (Array.isArray(resp?.data) ? resp.data : [])



        const map = {}



        records.forEach(record => {



          const elapsed = this.getElapsedSecondsFromPastPaper(record)



          let detail = record?.answerDetail



          if (typeof detail === 'string') {



            try {



              detail = JSON.parse(detail)



            } catch (e) {



              detail = null



            }



          }



          const code = detail?.code && typeof detail.code === 'object' ? detail.code : {}



          Object.keys(code).forEach(key => {



            const item = code[key]



            const questionId = Number(item?.questionId)



            if (!Number.isFinite(questionId) || questionId <= 0 || !elapsed) return



            const prev = map[String(questionId)]



            if (!prev || elapsed > prev.elapsedSeconds) {



              map[String(questionId)] = {



                elapsedSeconds: elapsed,



                year: record?.year,



                recordId: record?.id



              }



            }



          })



        })



        this.pastPaperDurationMap = map



        console.log('[QuestionRecords] pastPaperDurationMap', map)



      } catch (e) {



        console.warn('[QuestionRecords] 加载 pastPaper 用时失败', e)



      }



    },







    async loadCodeStatusRows(ids) {



      const resolved = await this.resolveGespCodeQuestionsByIdentifiers(ids)



      const codeIds = resolved.map(item => Number(item?.question?.id)).filter(id => Number.isFinite(id) && id > 0)



      console.log('[QuestionRecords] loadCodeStatusRows', {



        identifiers: ids,



        resolved: resolved.map(item => ({ identifier: item.identifier, questionId: item?.question?.id, number: item?.question?.number })),



        codeIds,



        userId: this.currentUserId



      })



      if (!codeIds.length || !this.currentUserId) return []







      await this.ensurePastPaperDurations()



      const submitResp = await getLatestSubmitBatch(this.currentUserId, codeIds)



      console.log('[QuestionRecords] getLatestSubmitBatch response', submitResp)



      const submitMap = submitResp?.data?.data ?? submitResp?.data ?? {}







      return resolved.map(item => {



        const question = item.question



        const qid = Number(question?.id)



        if (!Number.isFinite(qid) || qid <= 0) return null



        const submit = submitMap[String(qid)] || submitMap[qid]



        if (!submit) return null



        const row = this.normalizeCodeSubmitRecord(submit, question)



        const pastPaperMeta = this.pastPaperDurationMap[String(qid)]



        if (row && pastPaperMeta && pastPaperMeta.elapsedSeconds) {



          row.duration = `${pastPaperMeta.elapsedSeconds}秒`



        }



        return row



      }).filter(Boolean)



    },







    collectCodeIdentifiersFromStatusList(statusList) {



      const list = Array.isArray(statusList) ? statusList : []



      const out = []



      list.forEach(item => {



        this.getQuesIds(item).forEach(id => {



          if (this.isGespCodeIdentifier(id)) {



            out.push(String(id))



          }



        })



      })



      return Array.from(new Set(out))



    },







    mergeCodeRecordsIntoAllRecords(codeRows) {



      const codeList = Array.isArray(codeRows) ? codeRows.filter(Boolean) : []



      if (!codeList.length) return



      const merged = [...(Array.isArray(this.allRecords) ? this.allRecords : [])]



      const existsKeySet = new Set(



        merged.map(row => {



          const recordType = row?.recordType || row?.questionType || 'objective'



          const qid = row?.quesId != null ? String(row.quesId) : ''



          const submitTime = this.getRecordTime(row) || ''



          return `${recordType}__${qid}__${submitTime}`



        })



      )



      codeList.forEach(row => {



        const key = `${row?.recordType || row?.questionType || 'code'}__${row?.quesId != null ? String(row.quesId) : ''}__${this.getRecordTime(row) || ''}`



        if (!existsKeySet.has(key)) {



          merged.push(row)



          existsKeySet.add(key)



        }



      })



      this.allRecords = merged.sort((a, b) => {



        const at = new Date(this.getRecordTime(a) || 0).getTime()



        const bt = new Date(this.getRecordTime(b) || 0).getTime()



        return bt - at



      })



    },







    // 查看状态详情：点击卡片 -> 弹窗展示表格



    async viewStatusDetail(item) {



      try {



        const ids = this.getQuesIds(item)
        const targetDate = item && item.createDate ? String(item.createDate).slice(0, 10) : ''



        this.statusDetailTitle = `${item.source || '详情'}${targetDate ? `（${this.formatDateOnly(targetDate)}）` : ''}（共${ids.length}题）`



        this.showStatusDetailDialog = true



        this.statusDialogLoading = true







        if (!ids.length) {



          this.statusDetailRecords = []



          return



        }







        const objectiveIds = ids.filter(id => !this.isGespCodeIdentifier(id))



        const codeIdentifiers = ids.filter(id => this.isGespCodeIdentifier(id))



        const rows = []



        const resolvedQuesIds = new Set()



        const localRecordMap = new Map()



        ;(Array.isArray(this.allRecords) ? this.allRecords : []).forEach(r => {



          const qid = String(r?.quesId ?? '')



          if (qid) {



            if (!localRecordMap.has(qid)) localRecordMap.set(qid, [])



            localRecordMap.get(qid).push(r)



          }



        })



        const needFetchIds = []



        objectiveIds.forEach(id => {



          const local = localRecordMap.get(String(id))



          const matchedLocal = targetDate
            ? (local || []).filter(d => String(this.getRecordTime(d) || '').replace('T', ' ').slice(0, 10) === targetDate)
            : local

          if (matchedLocal && matchedLocal.length > 0) {



            matchedLocal.forEach(d => rows.push(d))



            resolvedQuesIds.add(String(id))



          } else {



            needFetchIds.push(id)



          }



        })



        const reqs = needFetchIds.map(id => getRecordsByQuesId(id, this.currentUserId))



        const resArr = await Promise.allSettled(reqs)



        resArr.forEach((r, idx) => {



          if (r.status === 'fulfilled') {



            const data = Array.isArray(r.value?.data) ? r.value.data : (r.value?.data ? [r.value.data] : [])



            data



              .filter(d => !this.currentUserId || String(d?.userId) === String(this.currentUserId))
              .filter(d => !targetDate || String(this.getRecordTime(d) || '').replace('T', ' ').slice(0, 10) === targetDate)



              .forEach(d => {



                rows.push(d)



                if (d?.quesId != null) resolvedQuesIds.add(String(d.quesId))



              })



          } else {



            console.warn('题目记录查询失败 quesId=', needFetchIds[idx], r.reason)



          }



        })







        const missingIds = objectiveIds.filter(id => !resolvedQuesIds.has(String(id)))



        if (codeIdentifiers.length) {



          const codeRows = await this.loadCodeStatusRows(codeIdentifiers)



          rows.push(...codeRows)



        }



        if (missingIds.length) {



          console.warn('[QuestionRecords] 未能解析到以下普通题记录，将不会按编程题处理:', missingIds)



        }







        const groupedRows = new Map()



        rows.forEach(row => {



          const keys = [String(row?.quesId || '')]



          if (row?.number) keys.push(String(row.number))



          keys.forEach(key => {



            if (!key) return



            const list = groupedRows.get(key) || []



            list.push(row)



            groupedRows.set(key, list)



          })



        })







        const orderedRows = []



        ids.forEach(id => {



          const matched = groupedRows.get(String(id)) || []



          matched.forEach(row => orderedRows.push(row))



        })







        const finalRows = orderedRows.length ? orderedRows : rows



        const enrichedRows = await this.enrichObjectiveRows(finalRows)







        this.statusDetailRecords = enrichedRows.sort((a, b) => {



          const at = new Date(this.getRecordTime(a) || 0).getTime()



          const bt = new Date(this.getRecordTime(b) || 0).getTime()



          return bt - at



        })







        // 加载知识点名称



        const allKnowledge = rows.map(r => r.knowledge).filter(k => k)



        if (allKnowledge.length > 0) {



          await this.ensureKnowledgeNames(allKnowledge)



        }



      } catch (e) {



        console.error('加载状态详情失败:', e)



        this.$message.error('加载详情失败')



        this.statusDetailRecords = []



      } finally {



        this.statusDialogLoading = false



      }



    },







    // 打开二级记录详情弹窗



    async openRecordDetail(row) {



      this.showRecordDetailDialog = true



      this.recordDetailLoading = true



      // 基础使用行内数据（保留中英文字段）



      this.recordDetail = { ...row }



      try {



        if (this.isCodeRecord(row)) {



          const res = await getGespQuestionById(row.quesId)



          const q = res && res.data ? res.data : null



          if (q) {



            this.recordDetail = {



              ...this.recordDetail,



              quesContent: q.description || q.content || q.title || this.recordDetail.quesContent,



              quescontentCn: q.description || q.content || q.title || this.recordDetail.quescontentCn || this.recordDetail.quesContentCn,



              quescontentEn: q.descriptionEn || q.contentEn || this.recordDetail.quescontentEn || this.recordDetail.quesContentEn,



              answer: this.recordDetail.answer || this.recordDetail.correctAnswer,



              correctAnswer: this.recordDetail.correctAnswer || this.recordDetail.answer,



              difficulty: q.difficulty || this.recordDetail.difficulty,



              knowledge: q.knowledge || this.recordDetail.knowledge,



              judge: this.recordDetail.judge,



              judgeCn: this.recordDetail.judgeCn,



              judgeEn: this.recordDetail.judgeEn



            }



          }



          return



        }



        // 若缺少图片或需要最新题目信息，补充题目详情



        if (!this.recordDetail.image || !this.recordDetail.quesContent) {



          const res = await getCourseQuestionById(row.quesId)



          const q = res?.data?.data ?? res?.data ?? res ?? null



          if (q) {



            this.recordDetail = {



              ...this.recordDetail,



              quesContent: q.content || q.quesContent || this.recordDetail.quesContent,



              quescontentCn: q.contentCn || q.quescontentCn || q.quesContentCn || this.recordDetail.quescontentCn || this.recordDetail.quesContentCn,



              quescontentEn: q.contentEn || q.quescontentEn || q.quesContentEn || this.recordDetail.quescontentEn || this.recordDetail.quesContentEn,



              image: q.image || this.recordDetail.image,



              answer: this.recordDetail.answer || q.answer || q.correctAnswer,



              judge: this.recordDetail.judge || q.analysis,



              judgeCn: q.analysisCn || q.judgeCn || this.recordDetail.judgeCn,



              judgeEn: q.analysisEn || q.judgeEn || this.recordDetail.judgeEn



            }



          }



        }



      } catch (e) {



        // 忽略错误，使用已有数据



      } finally {



        this.recordDetailLoading = false



      }



    },







    // 加载做题记录（按用户）



    async loadQuestionRecords() {



      this.loading = true



      this.error = null







      try {



        const repoId = this.$route?.query?.repoId || this.$route?.params?.repoId || null



        const response = await getRecordsByUserId(this.currentUserId, repoId)



        console.log(`按用户 ${this.currentUserId} 获取到的用户问题记录:`, response.data)







        if (response.data && Array.isArray(response.data)) {



          this.allRecords = response.data



          // 应用筛选



          this.applyFilters()



        } else {



          this.allRecords = []



          this.error = '暂无做题记录数据'



        }



      } catch (error) {



        console.error('获取做题记录失败:', error)



        this.error = '获取做题记录失败，请稍后重试'



        this.allRecords = []



      } finally {



        this.loading = false



      }



    },







    // 应用筛选



    applyFilters() {



      let filtered = [...this.allRecords]







      // 搜索关键词筛选（搜索中英文内容）



      if (this.searchKeyword) {



        const keyword = this.searchKeyword.toLowerCase()



        filtered = filtered.filter(record => {



          const contentCn = record.quescontentCn || record.quesContentCn || ''



          const contentEn = record.quescontentEn || record.quesContentEn || ''



          const contentFallback = record.quesContent || record.content || ''



          const allContent = (contentCn + ' ' + contentEn + ' ' + contentFallback).toLowerCase()



          return allContent.includes(keyword)



        })



      }







      // 答题状态筛选



      if (this.selectedStatus) {



        if (this.selectedStatus === 'correct') {



          filtered = filtered.filter(record => this.getRecordCorrect(record) === true)



        } else if (this.selectedStatus === 'incorrect') {



          filtered = filtered.filter(record => this.getRecordCorrect(record) === false)



        }



      }







      // 日期范围筛选



      if (this.dateRange && this.dateRange.length === 2) {



        const startDate = new Date(this.dateRange[0])



        const endDate = new Date(this.dateRange[1])



        endDate.setHours(23, 59, 59, 999) // 包含结束日期的整天







        filtered = filtered.filter(record => {



          const recTime = this.getRecordTime(record)



          if (!recTime) return false



          const recordDate = new Date(recTime)



          return recordDate >= startDate && recordDate <= endDate



        })



      }







      // 分页处理



      const start = (this.currentPage - 1) * this.pageSize



      const end = start + this.pageSize



      this.filteredRecords = filtered.slice(start, end)



    },







    // 搜索处理



    handleSearch() {



      this.currentPage = 1



      this.applyFilters()



    },







    // 筛选处理



    handleFilter() {



      this.currentPage = 1



      this.applyFilters()



    },







    // 日期筛选处理



    handleDateFilter() {



      this.currentPage = 1



      this.applyFilters()



    },







    // 分页大小改变



    handleSizeChange(val) {



      this.pageSize = val



      this.currentPage = 1



      this.applyFilters()



    },







    // 当前页改变



    handleCurrentChange(val) {



      this.currentPage = val



      this.applyFilters()



    },







    // 查看题目详情



    viewQuestionDetail(record) {



      // 先展示弹窗与加载态



      this.showQuestionDialog = true



      this.dialogLoading = true







      // 兜底的基础信息来自记录（保留中英文字段）



      const base = {



        quesId: record.quesId,



        quesContent: record.quesContent,



        quescontentCn: record.quescontentCn || record.quesContentCn,



        quescontentEn: record.quescontentEn || record.quesContentEn,



        image: record.image,



        userAnswer: record.userAnswer,



        correctAnswer: record.answer || record.correctAnswer,



        isCorrect: record.isCorrect,



        score: record.score,



        judge: record.judge,



        judgeCn: record.judgeCn,



        judgeEn: record.judgeEn,



        createTime: record.createTime



      }







  // 根据题目ID拉取详细信息



  getCourseQuestionById(record.quesId)



    .then(res => {



      const q = res?.data?.data ?? res?.data ?? res ?? null



      // 兼容不同字段命名，保留中英文字段



          const merged = {



            ...base,



            // 内容、选项、答案、解析等优先使用后端最新数据



            quesContent: q?.content || q?.quesContent || base.quesContent,



            quescontentCn: q?.contentCn || q?.quescontentCn || q?.quesContentCn || base.quescontentCn,



            quescontentEn: q?.contentEn || q?.quescontentEn || q?.quesContentEn || base.quescontentEn,



            image: q?.image || base.image,



            optionsStr: q?.optionsStr || q?.options || base.optionsStr,



            correctAnswer: q?.answer || q?.correctAnswer || base.correctAnswer,



            judge: q?.analysis || q?.judge || base.judge,



            judgeCn: q?.analysisCn || q?.judgeCn || base.judgeCn,



            judgeEn: q?.analysisEn || q?.judgeEn || base.judgeEn,



            knowledge: q?.knowledge || base.knowledge,



            difficulty: q?.difficulty || base.difficulty



          }



          this.selectedQuestion = merged



        })



        .catch(() => {



          // 失败时仍展示记录信息



          this.selectedQuestion = base



          this.$message.warning('获取题目详情失败，已显示记录中的内容')



        })



        .finally(() => {



          this.dialogLoading = false



        })



    },







    // 关闭题目详情弹窗



    handleCloseQuestionDialog() {



      this.showQuestionDialog = false



      this.selectedQuestion = null



    },







    // 刷新（临时仅刷新 AMC 状态，取消其他请求）



    refreshRecords() {



      // 同步刷新 AMC 状态与做题记录，确保顶部统计更新



      this.loadAmcStatusByUser()



      this.loadQuestionRecords()



    },







    // 根据语言模式获取题目内容



    getQuestionContent(record) {



      if (!record) return '暂无题目内容'







      const cn = record.quescontentCn || record.quesContentCn || record.contentCn || ''



      const en = record.quescontentEn || record.quesContentEn || record.contentEn || ''



      const fallback = record.quesContent || record.content || ''







      if (this.langMode === 'zh') {



        return cn || fallback || '暂无题目内容'



      } else if (this.langMode === 'en') {



        return en || fallback || '暂无题目内容'



      } else { // 双语



        if (cn && en) {



          return cn + '<br><br>' + en



        }



        return cn || en || fallback || '暂无题目内容'



      }



    },







    // 根据语言模式获取解析内容



    getJudgeContent(record) {



      if (!record) return '暂无解析内容'







      const cn = record.judgeCn || record.analysisCn || ''



      const en = record.judgeEn || record.analysisEn || ''



      const fallback = record.judge || record.analysis || ''







      if (this.langMode === 'zh') {



        return cn || fallback || '暂无解析内容'



      } else if (this.langMode === 'en') {



        return en || fallback || '暂无解析内容'



      } else { // 双语



        if (cn && en) {



          return cn + '<br><br>' + en



        }



        return cn || en || fallback || '暂无解析内容'



      }



    },







    // 格式化题目内容



    formatQuestionContent(content) {



      if (!content) return '暂无题目内容'



      return content.replace(/\n/g, '<br>')



    },







    // 统一解析图片URL（MinIO）



    resolveImageUrl(path) {



      return getMinioUrl(path)



    },







    // 格式化日期时间



    formatDateTime(dateTime) {



      if (!dateTime) return '未知时间'



      const date = new Date(dateTime)



      return date.toLocaleString('zh-CN', {



        year: 'numeric',



        month: '2-digit',



        day: '2-digit',



        hour: '2-digit',



        minute: '2-digit',



        second: '2-digit'



      })



    },



    formatDateOnly(dateTime) {



      if (!dateTime) return '未知日期'



      const value = String(dateTime).replace('T', ' ').trim()



      if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {



        return value.replace(/-/g, '/')



      }



      const date = new Date(value)



      if (isNaN(date.getTime())) {



        return value.slice(0, 10).replace(/-/g, '/') || '未知日期'



      }



      return date.toLocaleDateString('zh-CN', {



        year: 'numeric',



        month: '2-digit',



        day: '2-digit'



      })



    },







    // 解析知识点：将 ID 转换为名称



    resolveKnowledgeName(val) {



      if (val == null || val === '' || val === '-') return val || '-'



      const raw = String(val).trim()



      if (!raw || raw === '-') return raw



      // 如果全是数字和分隔符，说明是 ID 列表



      if (/^[0-9,，\s]+$/.test(raw)) {



        const ids = raw.split(/[,，\s]+/).filter(x => x)



        return ids.map(id => this.knowledgeNameMap[String(id)] || id).join('、')



      }



      return raw



    },







    // 确保知识点名称已加载



    async ensureKnowledgeNames(ids) {



      try {



        ids = Array.isArray(ids) ? ids : [ids]



        ids = ids



          .flatMap(v => (v == null ? [] : String(v).split(/[,，\s]+/)))



          .map(x => String(x).trim())



          .filter(x => x && /^\d+$/.test(x))



        const unique = Array.from(new Set(ids)).filter(id => !this.knowledgeNameMap[id])



        if (!unique.length) return



        const resp = await batchGetGeneralKnowledgeNames(unique)



        const data = resp?.data?.data ?? resp?.data ?? resp



        if (Array.isArray(data)) {



          data.forEach(item => {



            const id = item && (item.id ?? item.knowledgeId)



            const name = item && (item.content ?? item.name ?? item.title)



            if (id != null && name != null) this.$set(this.knowledgeNameMap, String(id), String(name))



          })



        } else if (data && typeof data === 'object') {



          Object.keys(data).forEach(k => this.$set(this.knowledgeNameMap, String(k), data[k]))



        }



      } catch (e) {



        console.warn('获取知识点名称失败:', e)



      }



    },







    // 将知识点字符串拆分为标签数组（用于详情弹窗）



    splitKnowledge(s) {



      if (!s) return []



      const raw = String(s)



      // 如果是 ID 列表，先转换为名称



      if (/^[0-9,，\s]+$/.test(raw)) {



        const ids = raw.split(/[,，\s]+/).filter(x => x)



        return ids.map(id => this.knowledgeNameMap[String(id)] || id)



      }



      // 否则直接拆分



      return raw.split(/[，,;；\s]+/).map(x => x.trim()).filter(Boolean)



    },







    // 返回上一页



    goBack() {



      this.$router.go(-1)



    },







    // 将难度数字或文字转换为统一的中文描述



    // 1-6: 入门, 7-12: 简单, 13-18: 一般, 19-25: 困难



    formatDifficulty(difficulty) {



      if (!difficulty) return '-'







      // 如果是数字或数字字符串



      const num = Number(difficulty)



      if (!isNaN(num)) {



        if (num >= 1 && num <= 6) return '入门'



        if (num >= 7 && num <= 12) return '简单'



        if (num >= 13 && num <= 18) return '一般'



        if (num >= 19 && num <= 25) return '困难'



        return difficulty // 超出范围则显示原值



      }







      // 如果已经是文字描述，直接返回



      return difficulty



    },







    // 获取难度标签类型



    getDifficultyType(difficulty) {



      if (!difficulty) return 'info'







      // 如果是数字或数字字符串，根据范围返回类型



      const num = Number(difficulty)



      if (!isNaN(num)) {



        if (num >= 1 && num <= 6) return 'success' // 入门-绿色



        if (num >= 7 && num <= 12) return '' // 简单-默认蓝色



        if (num >= 13 && num <= 18) return 'warning' // 一般-橙色



        if (num >= 19 && num <= 25) return 'danger' // 困难-红色



        return 'info'



      }







      // 如果是文字，根据关键词判断



      const d = String(difficulty).toLowerCase()



      if (d.includes('入门') || d.includes('easy') || d.includes('容易')) return 'success'



      if (d.includes('简单') || d.includes('simple')) return ''



      if (d.includes('一般') || d.includes('medium') || d.includes('中等') || d.includes('中')) return 'warning'



      if (d.includes('困难') || d.includes('hard') || d.includes('难')) return 'danger'



      return 'info'



    }



  }



}



</script>







<style lang="scss" scoped>



.question-records-container {



  min-height: 100vh;



  background-color: #f5f7fa;



  padding: 0;



  margin: 0;



  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;



}







/* 顶部导航栏 */



.records-header {



  background: #fff;



  padding: 15px 20px;



  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);



  position: sticky;



  top: 0;



  z-index: 100;



  display: flex;



  justify-content: space-between;



  align-items: center;



}







.header-left {



  display: flex;



  align-items: center;



  gap: 15px;



}







.header-right {



  display: flex;



  align-items: center;



}







.back-btn {



  font-size: 20px;



  color: #666;



  cursor: pointer;



  padding: 5px;



  border-radius: 50%;



  transition: background-color 0.3s;



}







.back-btn:hover {



  background-color: #f5f5f5;



}







.page-title {



  margin: 0;



  font-size: 18px;



  font-weight: 600;



  color: #333;



}







/* 统计信息 */



.stats-section {



  display: flex;



  gap: 20px;



  padding: 20px;



  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);



  color: white;



}







.stat-card {



  flex: 1;



  background: rgba(255, 255, 255, 0.15);



  border-radius: 12px;



  padding: 20px;



  text-align: center;



  backdrop-filter: blur(10px);



}







.stat-number {



  font-size: 32px;



  font-weight: bold;



  margin-bottom: 8px;



}







.stat-label {



  font-size: 14px;



  opacity: 0.9;



}







/* AMC 状态卡片 */



.amc-status-section {



  background: linear-gradient(135deg, #f0f4f8 0%, #e8eef5 100%);



  margin: 20px 0;



  border-radius: 16px;



  box-shadow: 0 4px 16px rgba(31, 45, 61, 0.06);



  padding: 20px;



  border: 1px solid rgba(102, 126, 234, 0.08);



}







.amc-status-header {



  display: flex;



  justify-content: space-between;



  align-items: baseline;



  margin-bottom: 16px;



  padding-bottom: 12px;



  border-bottom: 2px solid rgba(102, 126, 234, 0.1);



}



.amc-title {



  font-size: 20px;



  font-weight: 800;



  color: #1a202c;



  letter-spacing: .3px;



  background: linear-gradient(135deg, #667eea, #764ba2);



  -webkit-background-clip: text;



  -webkit-text-fill-color: transparent;



  background-clip: text;



}



.amc-subtitle { font-size: 13px; color: #a0aec0; font-weight: 500; }



.amc-status-loading, .amc-status-error, .amc-status-empty {



  color: #718096;



  padding: 16px 8px;



  text-align: center;



  font-weight: 500;



}







.amc-cards-grid {



  display: grid;



  grid-template-columns: 1fr;



  gap: 20px;



}







.amc-card {



  background: linear-gradient(135deg, #ffffff 0%, #f8fafb 100%);



  border: 1px solid rgba(102, 126, 234, 0.15);



  border-radius: 16px;



  padding: 18px 20px;



  transition: all .3s cubic-bezier(0.4, 0, 0.2, 1);



  box-shadow: 0 4px 16px rgba(31, 45, 61, 0.08);



  position: relative;



  overflow: hidden;



  cursor: pointer;



}







.amc-card::before {



  content: '';



  position: absolute;



  top: 0;



  left: 0;



  right: 0;



  height: 3px;



  background: linear-gradient(90deg, #667eea, #764ba2);



  opacity: 0;



  transition: opacity .3s ease;



}







.amc-card:hover {



  transform: translateY(-2px);



  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.15);



  border-color: rgba(102, 126, 234, 0.3);



  background: linear-gradient(135deg, #fafbfc 0%, #f3f6f9 100%);



}







.amc-card:hover::before {



  opacity: 1;



}







.amc-card:active {



  transform: translateY(-1px) scale(0.96);



}







.amc-card-header {



  display: flex;



  justify-content: space-between;



  align-items: center;



  margin-bottom: 16px;



  gap: 12px;



}







.amc-view-hint {



  font-size: 12px;



  color: #94a3b8;



  font-weight: 500;



  opacity: 0;



  transform: translateX(-10px);



  transition: all .3s ease;



  pointer-events: none;



}







.amc-card:hover .amc-view-hint {



  opacity: 1;



  transform: translateX(0);



  color: #667eea;



}







.amc-source {



  font-size: 13px;



  padding: 6px 14px;



  border-radius: 20px;



  font-weight: 600;



  letter-spacing: 0.3px;



  background: linear-gradient(135deg, #eef2ff, #f3f5ff);



  color: #5b6bff;



  border: 1px solid #e6ebff;



  box-shadow: 0 2px 8px rgba(91, 107, 255, 0.15);



  transition: all .2s ease;



}







.amc-source:hover {



  transform: scale(1.05);



  box-shadow: 0 4px 12px rgba(91, 107, 255, 0.25);



}







.amc-source.src-每日一题 {



  background: linear-gradient(135deg, #e8f7ff, #f1fbff);



  color: #1890ff;



  border-color: #d7f0ff;



  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.15);



}







.amc-source.src-连对挑战 {



  background: linear-gradient(135deg, #fff7e6, #fff9ef);



  color: #fa8c16;



  border-color: #ffe8c7;



  box-shadow: 0 2px 8px rgba(250, 140, 22, 0.15);



}







.amc-card-body {



  display: grid;



  grid-template-columns: repeat(3, 1fr);



  gap: 16px;



}







.amc-metric {



  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);



  border-radius: 12px;



  padding: 14px 16px;



  border: 1px solid rgba(102, 126, 234, 0.1);



  box-shadow: 0 2px 8px rgba(31, 45, 61, 0.06);



  transition: all .2s ease;



  display: flex;



  align-items: center;



  gap: 12px;



  position: relative;



  overflow: hidden;



}







.amc-metric::before {



  content: '';



  position: absolute;



  top: 0;



  left: 0;



  width: 100%;



  height: 2px;



  background: linear-gradient(90deg, transparent, rgba(102, 126, 234, 0.8), transparent);



  transform: translateX(-100%);



  transition: transform .6s ease;



}







.amc-metric:hover {



  transform: translateY(-1px);



  box-shadow: 0 4px 16px rgba(102, 126, 234, 0.12);



  border-color: rgba(102, 126, 234, 0.2);



  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);



}







.amc-metric:hover::before {



  transform: translateX(100%);



}







.amc-metric-icon {



  font-size: 20px;



  filter: drop-shadow(0 2px 4px rgba(102, 126, 234, 0.15));



  animation: float 3s ease-in-out infinite;



}







@keyframes float {



  0%, 100% { transform: translateY(0px); }



  50% { transform: translateY(-2px); }



}







.amc-metric-content {



  flex: 1;



}







.amc-metric-label {



  font-size: 12px;



  color: #64748b;



  letter-spacing: .4px;



  font-weight: 600;



  text-transform: uppercase;



  margin-bottom: 4px;



}







.amc-metric-value {



  font-size: 20px;



  font-weight: 800;



  color: #1e293b;



  line-height: 1;



}







.amc-metric-value.success {



  color: #10b981;



}







.amc-metric-value.warn {



  color: #f59e0b;



}







.amc-card-footer { margin-top: 8px; font-size: 12px; color: #666; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }



.amc-ids-label { color: #999; }



.amc-ids-value { color: #555; }







.error-content {



  text-align: center;



  padding: 40px;



}







.error-icon {



  font-size: 48px;



  color: #f56c6c;



  margin-bottom: 20px;



}







.error-message {



  font-size: 16px;



  color: #666;



  margin-bottom: 20px;



}







/* 做题记录内容 */



.records-content {



  padding: 20px;



}







/* 筛选区域 */



.filter-section {



  background: #fff;



  padding: 20px;



  border-radius: 8px;



  margin-bottom: 20px;



  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);



}







.filter-controls {



  display: flex;



  align-items: center;



  flex-wrap: wrap;



  gap: 15px;



}







/* 表格区域 */



.table-section {



  background: #fff;



  border-radius: 8px;



  padding: 20px;



  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);



}







.question-content {



  max-width: 300px;



  overflow: hidden;



  text-overflow: ellipsis;



  white-space: nowrap;



}







.user-answer, .correct-answer {



  font-weight: 600;



}







.user-answer {



  color: #1890ff;



}







.correct-answer {



  color: #52c41a;



}







.no-answer {



  color: #999;



  font-style: italic;



}







.score-correct {



  color: #52c41a;



  font-weight: 600;



}







.score-incorrect {



  color: #ff4d4f;



  font-weight: 600;



}







/* 分页 */



.pagination-section {



  display: flex;



  justify-content: center;



  margin-top: 20px;



}







/* 题目详情弹窗 */



.question-detail {



  padding: 20px;



}







.question-header {



  display: flex;



  justify-content: space-between;



  align-items: center;



  margin-bottom: 20px;



  padding-bottom: 15px;



  border-bottom: 2px solid #f0f0f0;



}







.question-header h3 {



  margin: 0;



  color: #333;



}







.question-content-detail {



  margin-bottom: 20px;



}







.question-content-detail h4 {



  margin: 0 0 10px 0;



  color: #333;



}







.content-text {



  background: #f8f9fa;



  padding: 15px;



  border-radius: 8px;



  line-height: 1.6;



  color: #333;



}







.answer-section {



  margin-bottom: 20px;



}







.answer-row {



  display: flex;



  align-items: center;



  margin-bottom: 10px;



  padding: 8px 0;



}







.answer-label {



  font-weight: 600;



  color: #666;



  margin-right: 15px;



  min-width: 80px;



}







.answer-value {



  font-weight: 500;



}







.answer-value.correct {



  color: #52c41a;



}







.answer-value.incorrect {



  color: #ff4d4f;



}







.time-section {



  border-top: 1px solid #f0f0f0;



  padding-top: 15px;



}







.time-row {



  display: flex;



  align-items: center;



}







/* 记录详情弹窗样式 */



.record-detail-dialog {



  .el-dialog__header {



    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);



    padding: 20px 40px;



    margin: 0;



  }







  .el-dialog__body {



    padding: 30px 40px;



    background: #f5f7fa;



    max-height: 80vh;



    overflow-y: auto;



  }







  .el-dialog__footer {



    padding: 15px 40px;



    border-top: 1px solid #e4e7ed;



  }



}







.record-dialog-title {



  display: flex;



  justify-content: space-between;



  align-items: center;



  color: white;







  .title-left {



    display: flex;



    align-items: center;



    gap: 10px;



    font-size: 18px;



    font-weight: 600;







    i {



      font-size: 20px;



    }



  }







  .title-right {



    .el-tag {



      font-size: 14px;



      padding: 8px 16px;



      border: none;







      i {



        margin-right: 4px;



      }



    }



  }



}







.record-detail-wrapper {



  .info-cards-row {



    display: grid;



    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));



    gap: 16px;



    margin-bottom: 24px;



  }







  .info-card {



    background: white;



    border-radius: 12px;



    padding: 20px;



    display: flex;



    align-items: center;



    gap: 16px;



    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);



    transition: all 0.3s ease;







    &:hover {



      transform: translateY(-4px);



      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);



    }







    .info-card-icon {



      width: 48px;



      height: 48px;



      border-radius: 12px;



      display: flex;



      align-items: center;



      justify-content: center;



      color: white;



      font-size: 24px;



      flex-shrink: 0;



    }







    .info-card-content {



      flex: 1;



      min-width: 0;







      .info-card-label {



        font-size: 12px;



        color: #909399;



        margin-bottom: 4px;



      }







      .info-card-value {



        font-size: 16px;



        font-weight: 600;



        color: #303133;



        word-break: break-all;



      }



    }



  }







  .knowledge-tags-section {



    background: white;



    border-radius: 12px;



    padding: 20px;



    margin-bottom: 24px;



    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);







    .knowledge-tags {



      display: flex;



      flex-wrap: wrap;



      gap: 10px;



      margin-top: 12px;



    }



  }







  .content-section {



    background: white;



    border-radius: 12px;



    padding: 24px;



    margin-bottom: 24px;



    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);



  }







  .section-title {



    display: flex;



    align-items: center;



    gap: 8px;



    font-size: 16px;



    font-weight: 600;



    color: #303133;



    margin-bottom: 16px;



    padding-bottom: 12px;



    border-bottom: 2px solid #f0f2f5;







    i {



      font-size: 18px;



      color: #667eea;



    }



  }







  .content-box {



    background: #f8f9fa;



    border-radius: 8px;



    padding: 24px;



    line-height: 2;



    color: #303133;



    max-height: none;



    overflow: visible;



    word-wrap: break-word;



    white-space: pre-wrap;



    width: 100%;



    box-sizing: border-box;







    &.record-question-content {



      font-size: 16px;



      border-left: 4px solid #667eea;



      min-height: 80px;



      padding: 24px 28px;







      div {



        width: 100%;



        max-width: 100%;



      }



    }







    &.analysis-content {



      background: #fff7e6;



      border-left: 4px solid #faad14;



      min-height: 80px;



      font-size: 15px;



      padding: 24px 28px;



    }







    &.note-content {



      background: #e6f7ff;



      border-left: 4px solid #1890ff;



      font-style: italic;



      min-height: 60px;



      font-size: 15px;



    }



  }







  .question-image {



    max-width: 100%;



    border-radius: 8px;



    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);



    display: block;



  }







  .answer-comparison {



    display: grid;



    grid-template-columns: 1fr auto 1fr;



    gap: 20px;



    align-items: center;



    margin-bottom: 24px;







    .answer-box {



      background: white;



      border-radius: 12px;



      padding: 20px;



      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);



      transition: all 0.3s ease;







      &:hover {



        transform: translateY(-2px);



        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);



      }







      .answer-header {



        display: flex;



        align-items: center;



        gap: 8px;



        font-size: 14px;



        font-weight: 600;



        color: #606266;



        margin-bottom: 12px;







        i {



          font-size: 16px;



        }



      }







      .answer-content {



        font-size: 24px;



        font-weight: 700;



        color: #303133;



        text-align: center;



        padding: 12px;



        background: #f8f9fa;



        border-radius: 8px;



      }







      &.user-answer {



        border: 2px solid #409eff;







        .answer-header {



          color: #409eff;



        }







        .answer-content {



          color: #409eff;



          background: #ecf5ff;



        }







        &.wrong-answer {



          border-color: #f56c6c;







          .answer-header {



            color: #f56c6c;



          }







          .answer-content {



            color: #f56c6c;



            background: #fef0f0;



          }



        }



      }







      &.correct-answer {



        border: 2px solid #67c23a;







        .answer-header {



          color: #67c23a;



        }







        .answer-content {



          color: #67c23a;



          background: #f0f9ff;



        }



      }



    }







    .answer-divider {



      display: flex;



      align-items: center;



      justify-content: center;







      i {



        font-size: 32px;



        font-weight: bold;



      }



    }



  }







  .meta-info {



    display: flex;



    flex-wrap: wrap;



    gap: 20px;



    padding: 16px;



    background: white;



    border-radius: 8px;



    font-size: 13px;



    color: #909399;



    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);







    span {



      display: flex;



      align-items: center;



      gap: 6px;







      i {



        color: #c0c4cc;



      }



    }



  }



}







@media (max-width: 768px) {



  .record-detail-wrapper {



    .info-cards-row {



      grid-template-columns: 1fr;



    }







    .answer-comparison {



      grid-template-columns: 1fr;







      .answer-divider {



        transform: rotate(90deg);



      }



    }



  }



}







.time-label {



  font-weight: 600;



  color: #666;



  margin-right: 15px;



}







.time-value {



  color: #333;



}







/* 解析部分 */



.analysis-section {



  background: #f8f9fa;



  padding: 20px;



  border-radius: 8px;



  margin: 20px 0;



  border-left: 4px solid #409eff;



}







.analysis-section h4 {



  margin: 0 0 15px 0;



  color: #333;



  font-size: 16px;



  font-weight: 600;



}







.analysis-content {



  font-size: 14px;



  line-height: 1.6;



  color: #666;



}







/* 响应式设计 */



@media (max-width: 768px) {



  .records-header {



    padding: 10px 15px;



    flex-direction: column;



    gap: 10px;



  }







  .header-left {



    width: 100%;



    justify-content: space-between;



  }







  .header-right {



    width: 100%;



    justify-content: center;



  }







  .stats-section {



    flex-direction: column;



    gap: 15px;



    padding: 15px;



  }







  .filter-controls {



    flex-direction: column;



    align-items: stretch;



  }







  .filter-controls > * {



    width: 100% !important;



    margin-right: 0 !important;



    margin-bottom: 10px;



  }







  .records-content {



    padding: 15px;



  }







  .table-section {



    padding: 15px;



    overflow-x: auto;



  }







  .question-header {



    flex-direction: column;



    align-items: flex-start;



    gap: 10px;



  }



}







@media (max-width: 480px) {



  .stat-number {



    font-size: 24px;



  }







  .answer-row {



    flex-direction: column;



    align-items: flex-start;



  }







  .answer-label {



    margin-bottom: 5px;



  }



}



</style>



